






import { Vue, Component, Prop } from "vue-property-decorator";
import Destacados from "@/components/Beneficios/DestacadosComponent.vue";

@Component({
  components: {
    Destacados
  }
})
export default class ConveniosView extends Vue {
  private mounted() {}
}
